import { useEffect, useState } from "react";
import dayjs from "dayjs";
import TableManagement from "./tables";
import useTableFeatureHandlers from "./useTableFeatureHandlers";
import ReservationsManagementPanel from "./ReservationsManagementPanel";
import ReservationsDrawer from "./ReservationsDrawer";
import MergeSplitDrawer from "./MergeSplitDrawer";
import WaitlistDrawer from "./WaitlistDrawer";
import SeatGuestDrawer from "./SeatGuestDrawer";
import CheckInDrawer from "./CheckInDrawer";

const TableFeatures = (props) => {
  const {
    open,
    onCancel,
    onConfirm,
    drawerOpen,
    closeDrawer,
    reservations,
    mergeDrawerOpen,
    closeMergeDrawer,
    mergeTablesList,
    waitlistDrawerOpen,
    closeWaitlistDrawer,
    waitlistData,
    waitlistTab,
    setWaitlistTab,
    waitlistForm,
    setWaitlistForm,
    validateWaitlistForm,
    waitlistErrors,
    setWaitlistErrors,
    waitlistList,
    setWaitlistList,
    getWaitlist,
    saveToWaitlist,
    waitlistSubmitting,
    reservationList,
    setReservationList,
    form,
    setForm,
    errors,
    setErrors,
    handleCancelReservation,
    selectData,
    setSelectData,
    tableList,
    setTableList,
    reserveModalOpen,
    setReserveModalOpen,
    setDrawerOpen,
    setWaitlistDrawerOpen,
    setTableCards,
    setOcupiedTablesData,
    setReservedTablesData,
    setMainTableData,
    handleTable,
    setReservationsBlank,
    reservationsBlank,
    loadReservations,
    setDisplayReserveTablesPopup,
    handleReserveTable,
    setFieldsValue,
    displayReserveTablesPopup,
    guestForm,
    handleNumberClick,
    reserveTableForm,
    handleClick,
    inputFields,
    setInputFields,
    numbers,
    setNumberOfPersons,
    noOfPersons,
    handleOnChange,
    loadWaitlistForUI,
    setReservePhone,
    reservePhone,
    addNewCustomer,
    cart,
    setCart,
    seatGuestDrawerOpen,
    setSeatGuestDrawerOpen,
    transferBill,
    setTransferBill,
    tableCards,
    selectedTable,
    keyValue,
    setShowProducts,
    clearCartData,
    setLoading,
  } = props;

  const [activeFeatureTab, setActiveFeatureTab] = useState("reservations");

  const handlers = useTableFeatureHandlers({
    tableList,
    tableCards,
    setTableCards,
    setTableList,
    setMainTableData,
    setOcupiedTablesData,
    setReservedTablesData,
    setCart,
    setSeatGuestDrawerOpen,
    setTransferBill,
    setShowProducts,
    setLoading,
    handleTable,
    setDrawerOpen,
    saveToWaitlist,
    waitlistForm,
    setWaitlistForm,
    waitlistErrors,
    setWaitlistErrors,
    validateWaitlistForm,
    setWaitlistList,
    setWaitlistTab,
    closeMergeDrawer,
    cart,
  });

  const {
    selectedWaitlistGuest,
    setSelectedWaitlistGuest,
    selectedTableForSeating,
    setSelectedTableForSeating,
    mergeOrSplitAction,
    setMergeOrSplitAction,
    selectedTablesForMerge,
    setSelectedTablesForMerge,
    checkInDrawerOpen,
    setCheckInDrawerOpen,
    selectedReservation,
    setSelectedReservation,
    phoneError,
    handleSeatGuestToTable,
    handleTransferBill,
    resetWaitlistForm,
    handleWaitlistContactSearch,
    handleReservationCheckIn,
    handleTableSelection,
    handleActionChange,
    handleSplitTableClick,
    handleMergeTables,
    isNormalAvailableTable,
    getSplitSubTables,
  } = handlers;

  // Show only TODAY + not closed
  const today = dayjs().format("YYYY-MM-DD");
  const filteredWaitlist = waitlistList.filter((guest) => {
    const createdDate = dayjs(guest.created).format("YYYY-MM-DD");
    return guest.status !== "CL" && createdDate === today;
  });

  const filteredReservations = reservationList.filter((res) => {
    return true; // ReservationsDrawer manages its own search/date filters internally
  });

  const countNewReservations = reservationList
    ? reservationList.filter((res) => res.status === "NEW").length
    : 0;

  useEffect(() => {
    // focus side-effects for open modal handled in sub-components
  }, [open]);

  return (
    <>
      {keyValue === "4" && (
        <ReservationsManagementPanel
          activeFeatureTab={activeFeatureTab}
          setActiveFeatureTab={setActiveFeatureTab}
          reservationList={reservationList}
          filteredReservations={reservationList.filter((res) => res.status !== "CL")}
          filteredWaitlist={filteredWaitlist}
          countNewReservations={countNewReservations}
          loadReservations={loadReservations}
          loadWaitlistForUI={loadWaitlistForUI}
          setWaitlistList={setWaitlistList}
          setWaitlistTab={setWaitlistTab}
          setWaitlistDrawerOpen={setWaitlistDrawerOpen}
          resetWaitlistForm={resetWaitlistForm}
          handleReserveTable={handleReserveTable}
          setSelectedReservation={setSelectedReservation}
          setCheckInDrawerOpen={setCheckInDrawerOpen}
          saveToWaitlist={saveToWaitlist}
          setSeatGuestDrawerOpen={setSeatGuestDrawerOpen}
          setSelectedWaitlistGuest={setSelectedWaitlistGuest}
        />
      )}

      <ReservationsDrawer
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        reservationList={reservationList}
        handleReservationCheckIn={handleReservationCheckIn}
      />

      <MergeSplitDrawer
        mergeDrawerOpen={mergeDrawerOpen}
        closeMergeDrawer={closeMergeDrawer}
        tableList={tableList}
        mergeOrSplitAction={mergeOrSplitAction}
        setMergeOrSplitAction={setMergeOrSplitAction}
        selectedTablesForMerge={selectedTablesForMerge}
        setSelectedTablesForMerge={setSelectedTablesForMerge}
        handleTableSelection={handleTableSelection}
        handleActionChange={handleActionChange}
        handleMergeTables={handleMergeTables}
        handleSplitTableClick={handleSplitTableClick}
        isNormalAvailableTable={isNormalAvailableTable}
        getSplitSubTables={getSplitSubTables}
      />

      <WaitlistDrawer
        waitlistDrawerOpen={waitlistDrawerOpen}
        setWaitlistDrawerOpen={setWaitlistDrawerOpen}
        waitlistTab={waitlistTab}
        setWaitlistTab={setWaitlistTab}
        waitlistForm={waitlistForm}
        setWaitlistForm={setWaitlistForm}
        waitlistErrors={waitlistErrors}
        saveToWaitlist={saveToWaitlist}
        waitlistSubmitting={waitlistSubmitting}
        numbers={numbers}
        handleWaitlistContactSearch={handleWaitlistContactSearch}
        phoneError={phoneError}
      />

      <SeatGuestDrawer
        seatGuestDrawerOpen={seatGuestDrawerOpen}
        setSeatGuestDrawerOpen={setSeatGuestDrawerOpen}
        transferBill={transferBill}
        setTransferBill={setTransferBill}
        tableList={tableList}
        tableCards={tableCards}
        selectedTable={selectedTable}
        selectedWaitlistGuest={selectedWaitlistGuest}
        selectedTableForSeating={selectedTableForSeating}
        setSelectedTableForSeating={setSelectedTableForSeating}
        handleSeatGuestToTable={handleSeatGuestToTable}
        handleTransferBill={handleTransferBill}
      />

      <CheckInDrawer
        checkInDrawerOpen={checkInDrawerOpen}
        setCheckInDrawerOpen={setCheckInDrawerOpen}
        selectedReservation={selectedReservation}
        tableList={tableList}
        handleReservationCheckIn={handleReservationCheckIn}
      />

      {displayReserveTablesPopup && (
        <TableManagement
          {...props}
          setDisplayReserveTablesPopup={setDisplayReserveTablesPopup}
          displayReserveTablesPopup={displayReserveTablesPopup}
          guestForm={guestForm}
        />
      )}
    </>
  );
};

export default TableFeatures;
